// Untuk Navigasi gunakan NAVIGATION, untuk deklarasi route gunakan ROUTES
const ROUTES = {
  auth: {
    login: "/login",
    register: "/register"
  },
  intent: "/intent/home",
  intent_create: "/intent/:action",
  intent_detail: "/intent/detail",
  playground: "/playground",
  docs: "/documentation/home",
};

// Untuk Navigasi gunakan NAVIGATION, untuk deklarasi route gunakan ROUTES
const NAVIGATION = {
  auth: {
    login: "/login",
    register: "/register"
  },
  intent: "/intent/home",
  intent_create: "/intent/create",
  intent_edit: "/intent/edit",
  intent_detail: "/intent/detail",
  playground: "/playground",
  docs: "/documentation/home",
}

export { ROUTES, NAVIGATION };


